export default __webpack_public_path__ + "static/media/shortlistTemplate.0976d748.xlsx";